import { h } from 'preact'
import Tabs from '../Tabs'
import LeaderboardUserList from './LeaderboardUserList'
import Phrase from '../../libs/translationsUtils/phrase'

let tabs = ['thisWeek', 'allTime']

type tabType = 'thisWeek' | 'allTime'
interface CustomDisplayOptions {
    maxResults: number,
    visibleTabs: Array<tabType>,
    emptyMessage: string,
    excludeUserRole?: Array<string>,
    showLink?: boolean,
    linkText?: string,
    showLoggedInUserSection?: boolean
}

const PointsLeaderboard = (props: CustomDisplayOptions) => {
  tabs = props.visibleTabs ? props.visibleTabs : tabs
  const tabTitles = tabs.map(tab => {
    return <Phrase p={`leaderboard.points.${tab}`} />
  })
  return (
    <div className='leaderboard-container'>
      <Tabs titles={tabTitles}>
        {tabs.map(tab => <LeaderboardUserList
          key={tab}
          tabTitle={tab}
          maxResults={props.maxResults}
          excludeUserRole={props.excludeUserRole ? props.excludeUserRole : []}
          emptyMessage={props.emptyMessage}
          showLink={props.showLink}
          linkText={props.linkText}
          showLoggedInUserSection={props.showLoggedInUserSection}
        />)}
      </Tabs>
    </div>
  )
}

export default PointsLeaderboard
